import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Square, RectangleHorizontal, Pencil } from 'lucide-react';
export type WallTemplate = 'free' | 'rectangle' | 'l-shape' | 'u-shape' | 'galley';
interface TemplateDrawerProps {
  isOpen: boolean;
  selectedTemplate: WallTemplate;
  onSelectTemplate: (template: WallTemplate) => void;
}
const templates = [{
  id: 'free' as WallTemplate,
  icon: Pencil,
  label: 'Free Draw',
  description: 'Click to draw walls'
}, {
  id: 'rectangle' as WallTemplate,
  icon: Square,
  label: 'Rectangle',
  description: 'Drag to create room'
}, {
  id: 'l-shape' as WallTemplate,
  icon: LSquare,
  label: 'L-Shape',
  description: 'Corner room layout'
}, {
  id: 'u-shape' as WallTemplate,
  icon: USquare,
  label: 'U-Shape',
  description: 'Room with niche'
}, {
  id: 'galley' as WallTemplate,
  icon: RectangleHorizontal,
  label: 'Galley',
  description: 'Parallel walls'
}];
// Custom L-Shape icon component
function LSquare({
  size = 24
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-485">
      <path d="M4 4 L4 20 L20 20 L20 12 L12 12 L12 4 Z" data-id="element-486" />
    </svg>;
}
// Custom U-Shape icon component
function USquare({
  size = 24
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-487">
      <path d="M4 4 L4 20 L20 20 L20 4 L16 4 L16 16 L8 16 L8 4 Z" data-id="element-488" />
    </svg>;
}
export function TemplateDrawer({
  isOpen,
  selectedTemplate,
  onSelectTemplate
}: TemplateDrawerProps) {
  return <AnimatePresence data-id="element-489">
      {isOpen && <motion.div initial={{
      x: -20,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -20,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 30
    }} className="absolute left-20 top-[88px] bg-[#1e1e1e] border border-[#333] rounded-lg shadow-2xl overflow-hidden z-50" data-id="element-490">
          <div className="p-3 border-b border-[#333]" data-id="element-491">
            <div className="text-[#888] text-xs font-mono" data-id="element-492">WALL TEMPLATES</div>
          </div>

          <div className="p-2 space-y-1" data-id="element-493">
            {templates.map(template => {
          const Icon = template.icon;
          const isSelected = selectedTemplate === template.id;
          return <motion.button key={template.id} onClick={() => onSelectTemplate(template.id)} whileHover={{
            x: 2
          }} whileTap={{
            scale: 0.98
          }} className={`
                    w-full px-3 py-2.5 rounded-lg flex items-center gap-3
                    transition-colors text-left
                    ${isSelected ? 'bg-[#2563eb] text-white' : 'text-[#888] hover:bg-[#2a2a2a] hover:text-white'}
                  `} data-id="element-494">
                  <Icon size={20} data-id="element-495" />
                  <div className="flex-1 min-w-0" data-id="element-496">
                    <div className="text-sm font-mono" data-id="element-497">{template.label}</div>
                    <div className={`text-xs ${isSelected ? 'text-blue-200' : 'text-[#666]'}`} data-id="element-498">
                      {template.description}
                    </div>
                  </div>
                </motion.button>;
        })}
          </div>
        </motion.div>}
    </AnimatePresence>;
}